import React from 'react';
import { FadeIn } from './FadeIn';
export function Transition() {
  return <section className="bg-brand-beige py-20 px-6" data-id="element-453">
      <div className="max-w-3xl mx-auto text-center" data-id="element-454">
        <FadeIn data-id="element-455">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-6" data-id="element-456">
            La mayoría se queda aquí…
          </h2>
          <p className="text-lg md:text-xl text-brand-text/70 mb-4 leading-relaxed" data-id="element-457">
            Aprenden a vender en Amazon y generan sus primeras ganancias.
          </p>
          <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold mb-6" data-id="element-458">
            Pero los que realmente crecen… dan el siguiente paso.
          </p>
          <p className="text-lg text-brand-text/70 mb-2" data-id="element-459">
            No se quedan vendiendo productos.
          </p>
          <p className="text-lg text-brand-green font-semibold mb-8" data-id="element-460">
            Crean su propia marca.
          </p>
          <p className="text-lg text-brand-text/60 leading-relaxed" data-id="element-461">
            Cuando estés listo, también podrás aprender a trabajar con
            proveedores en China y construir algo mucho más grande.
          </p>
        </FadeIn>
      </div>
    </section>;
}